import API from "libs/api";
import { createAuthInstance } from "libs/request";
// @ts-ignore
import config from "config/index";

class UserAPI extends API {
  constructor(props?) {
    super(props);

    this.instance = this.createInstance(
      `${config.api.auth}user/`,
      createAuthInstance
    );
  }

  getChannels = (userId, params = {}) => this.instance.get(`/${userId}/channel`, {
    params
  });

  createUser(payload = {}) {
		return this.instance.post('/', payload);
	}

	updateUser(id, payload = {}) {
		return this.instance.put(`/${id}`, payload);
	}

	deleteUser(id) {
		return this.instance.delete(`/${id}`);
	}

	getUserById(id) {
		return this.instance.get(`/${id}`);
	}

	getUserByUsername(username) {
		return this.instance.get(`/getinfo/${username}`);
	}

	searchUsers(params = {}) {
		return this.instance.get('/', {
			params
		});
	}

	changePassword(payload = {}) {
		return this.instance.post('/changePassword', payload);
	}

	resetPassword(id, payload = {}) {
		return this.instance.put(`/${id}/reset-password`, payload);
	}

	getApplications(id, params = {}) {
		return this.instance.get(`/${id}/application`, {
			params
		});
	}
}

export default UserAPI;
